module.exports = __webpack_public_path__ + "img/26.4974fcb1.png";